export const USER_SEARCH_KEYS = {
  fullName: 'full_name',
  email: 'email',
  createdDate: 'createdDate',
  deactivatedDate: 'deactivatedDate',
  updatedDate: 'updatedDate',
};
